class CustomPromptTypes {
  static PAYMENT_SYSTEMS = "paymentSystems";

  static PAYROLL_SYSTEMS = "payrollSystems";

  static EXPENSE_REIMBURSEMENTS = "expenseReimbursements";

  static MARKETPLACES = "marketplaces";

  static TRANSFERS = "transfers";

  static PERSON_TO_PERSON_PAYMENTS = "p2pPayments";

  static ATM_WITHDRAWALS = "atmWithdrawals";

  static CHECKS = "checks";

  static ADDITIONAL = "additional";
}

export default CustomPromptTypes;
